import s from './Badge.module.scss';
import { usewpdataSelectors } from '@lib/wpdataState/selectors';

interface CustomProperties extends React.CSSProperties {
  '--badge-best-seller'?: string;
  '--badge-best-value'?: string;
  marginRight?: string | number;
}

interface Props {
  text: string;
  isBestSeller: boolean;
  modifiers?: {
    marginRight?: string | number;
  };
}

const BestSellerBadge = ({ text, isBestSeller, modifiers }: Props) => {
  const { hero } = usewpdataSelectors();

  return (
    <div
      style={
        {
          '--badge-best-seller': hero.styles.bestSellerColor,
          '--badge-best-value': hero.styles.bestValueColor,
        } as CustomProperties
      }
    >
      <div
        className={`${s.badge} ${isBestSeller ? s['badge--seller'] : ''} ${!isBestSeller ? s['badge--value'] : ''}`}
        style={{ marginRight: modifiers?.marginRight }}
      >
        {text}
      </div>
    </div>
  );
};

export default BestSellerBadge;
